// 화면 안내용 표시 계수(정책 표기: 30자당 무우 1개). 실제 차감 로직과는 별개.
export const MOOWOO_PER_MESSAGE = 1;

/** 잔량 단계 기준 */
// 1차 경고 기준. 잔량 100 이하부터 저잔량 경고 노출.
export const THRESHOLD_LOW = 100;
// 2차 경고 기준. 잔량 50 이하부터 소진 임박 경고 노출.
export const THRESHOLD_CRITICAL = 50;

/** 유효기간 (개월) */
export const EXPIRY_MONTHS = 9;

// 무료 제공분 유효기간(개월). 유료 충전분 9개월과는 별개.
export const FREE_MOOWOO_VALID_MONTHS = 1;

export function calcFreeExpiryDate(startDate) {
  if (!startDate) return null;
  const date = new Date(startDate);
  const originalDate = date.getDate();
  const targetMonth = date.getMonth() + FREE_MOOWOO_VALID_MONTHS;
  const expectedMonth = targetMonth % 12;
  
  date.setMonth(targetMonth);
  
  // 만약 1월 31일에 1달을 더해서 2월(최대 28/29일)을 넘어가 3월 3일 등이 된 경우
  // 월이 기대한 달(2월)과 다르다면, 달을 하나 빼고(0일) 전월의 마지막 날로 보정
  if (date.getMonth() !== expectedMonth) {
    date.setDate(0);
  }
  return date;
}

export const REGION_PACKS = {
  KR: {
    amount: 5000,
    price: 5500,
    prefix: '',
    suffix: '원',
    taxIncluded: true
  },
  GLOBAL: {
    amount: 8000,
    price: 4.99,
    prefix: '$',
    suffix: '',
    taxIncluded: false
  }
};

/**
 * 현재는 화면 언어로 지역을 판별하는 임시 방식임.
 * 한계: 한국 사용자가 앱 언어를 영어로 바꾸면 GLOBAL 상품이 표시되어 실제 청구액과 어긋날 수 있음.
 * 전환 시점: 실제 PG(PayPal 등) 연동 시.
 * 전환 방법: 서버가 접속 IP로 판별한 국가 코드를 받아, 이 함수 내부만 그 값을 읽도록 교체한다.
 * 상품표, MoowooPackCard, 결제 화면 등 호출부는 수정할 필요 없음.
 * 최종 청구 통화와 금액은 PG/서버가 확정하므로, 화면 표시는 참고값임.
 */
export function getRegion(locale) {
  return String(locale || '').toLowerCase().startsWith('ko') ? 'KR' : 'GLOBAL';
}

export function getRegionPack(locale) {
  return REGION_PACKS[getRegion(locale)];
}

/** 무우 → 보낼 수 있는 메시지 수 (100단위 내림, 과대광고 방지) */
export function messageCount(moowoo) {
  const raw = Math.floor(moowoo / MOOWOO_PER_MESSAGE);
  if (raw < 100) return raw;
  return Math.floor(raw / 100) * 100;
}

// 메시지 1건당 무우 소모량. 소수점은 올림하여 항상 정수로 처리.
export function calcMoowooCost(charLength) {
  const cost = Math.ceil(charLength / 30);
  return cost > 0 ? cost : 1;
}

/** 잔량 단계 */
export function moowooLevel(balance) {
  if (balance <= 0) return 'empty';
  if (balance <= THRESHOLD_CRITICAL) return 'critical';
  if (balance <= THRESHOLD_LOW) return 'low';
  return 'normal';
}

export const LEVEL_TEXT_COLOR = {
  normal:   'text-primary',
  low:      'text-warning',
  critical: 'text-error',
  empty:    'text-moowoo-balance-error',
};

/** 무우 숫자 포맷 (ko -> ko-KR, 그 외 -> en-US) */
export function formatMoowoo(value, locale) {
  const code = String(locale || '').toLowerCase().startsWith('ko') ? 'ko-KR' : 'en-US';
  return Number(value).toLocaleString(code);
}

// 번역 톤 허용값 (C-9)
export const ALLOWED_TONES = ['basic', 'polite', 'casual'];
export const DEFAULT_TONE = 'basic';
